// Set business logic - delegates to shared utilities with web-specific extensions

import type { ProcessedSet, SetStatus } from "@workspace/types";
import { 
	getSetStatus,
	getSetButtonTitle as getSharedSetButtonTitle,
	getSetButtonText as getSharedSetButtonText,
	type SetStatusInfo,
} from "@workspace/shared-utils";
import { isSetPast } from "@/lib/utils/date/formatting";

// Re-export shared types and functions
export type { SetStatus, SetStatusInfo };
export { getSetStatus };

// ===== BUTTON CONTENT LOGIC =====

/**
 * Gets button title text based on status and set timing
 * Web-specific version that handles ProcessedSet
 */
export function getSetButtonTitle(
	status: SetStatus,
	set?: ProcessedSet,
): string {
	const isPast = set ? isSetPast(set) : false;
	return getSharedSetButtonTitle(status, isPast);
}

/**
 * Gets button content text only (no icons) based on status and set timing
 * Web-specific version that handles ProcessedSet
 */
export function getSetButtonText(
	status: SetStatus,
	set?: ProcessedSet,
): string {
	const isPast = set ? isSetPast(set) : false;
	return getSharedSetButtonText(status, isPast);
}
